'use client'

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from './useAuth'
import {
  getUserLearningPreferences,
  upsertUserLearningPreferences,
  type UserLearningPreferences
} from '@/lib/learning-preferences'

export function useLearningPreferences() {
  const { user } = useAuth()

  return useQuery({
    queryKey: ['learning-preferences', user?.id],
    queryFn: () => getUserLearningPreferences(),
    enabled: Boolean(user?.id),
    staleTime: 1000 * 60 * 5
  })
}

export function useUpsertLearningPreferences() {
  const { user } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      input: Partial<
        Pick<UserLearningPreferences, 'goal' | 'level' | 'start_node_id'>
      >
    ) => {
      if (!user?.id) throw new Error('User not logged in')
      return upsertUserLearningPreferences(user.id, input)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['learning-preferences', user?.id]
      })
    }
  })
}
